  <!-- Animated -->
            <div class="animated fadeIn">
                <h3>{{userType | titlecase}} Panel</h3>
                <br/>
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Change Password </h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                           		<div class="row form-group">
                                    <div class="col col-md-3"><label for="oldPassword" class=" form-control-label">
                                        Old Password
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="oldPassword" [(ngModel)]="oldPassword" id="oldPassword" type="password" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="newPassword"  class=" form-control-label">
                                        New Password
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="newPassword" [(ngModel)]="newPassword" type="password" id="newPassword" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Confirm Password
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="confirmPassword" id="confirmPassword" type="password" [(ngModel)]="confirmPassword" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                               
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="changePassword()" >Change Password</button>
                                        </div>

                                    </div>

                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-12" id="errCont"></div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
                
            </div>
            <!-- .animated -->






<!--<div class="loaderbox" *ngIf="loaderVisibility" id="loaderbox">
    <div class="load" >
        <img src="assets/images/loading.gif" alt="" >
    </div>
</div>
-->


















